export const ReferralType = Object.freeze({
  EyeExam: 'Eye exam',
  NeuropsychologicalTesting: 'Neuropsychological testing',
  PETCTMetabolic: 'PET CT metabolic',
  PETCTAmyloid: 'PET CT amyloid',
  MRIBrainWithoutContrast: 'MRI brain without contrast',
  MRIBrainWithContrast: 'MRI brain with contrast',
  CTBrainWithoutContrast: 'CT brain without contrast',
  CTBrainWithContrast: 'CT brain with contrast',
  ChestXray: 'Chest Xray',
  DrivingTest: 'Driving test',
  EEG: 'EEG',
  AmbulatoryVideoEEGFor72Hours: 'Ambulatory video EEG for 72 hours',
  PhysicalTherapy: 'Physical therapy',
  HomeSafetyEvaluationByPhysicalTherapy: 'Home safety evaluation by physical therapy',
  OccupationalTherapy: 'Occupational therapy',
  SpeechLanguagePathology: 'Speech language pathology',
  SocialWork: 'Social work',
  Psychiatry: 'Psychiatry',
  SleepStudy: 'Sleep study',
});

export const ReferralStatus = Object.freeze({
  Sent: 'Sent',
});

export const PreferredLocation = Object.freeze({
  BethIsraelLahey: 'Beth Israel Lahey',
  MassGeneral: 'Mass General',
  Rayus: 'Rayus',
  ShieldsImaging: 'Shields Imaging',
  KSKImaging: 'KSK Imaging',
  Other: 'Other',
});

export const ReferralTypeOptions = Object.values(ReferralType).map((type) => ({
  value: type,
  label: type,
}));

export const ReferralStatusOptions = Object.values(ReferralStatus).map((status) => ({
  value: status,
  label: status,
}));

export const PreferredLocationOptions = Object.values(PreferredLocation).map((location) => ({
  value: location,
  label: location,
}));
